<template>
  <v-card-text>
    <v-card-text class="pl-0">
      <v-checkbox
        v-model="is_all_auth"
        label="授予全權"
        color="primary"
        hide-details
        class=""
        :disabled="staff_role === 1"
        @change="selectAllAuth"
      ></v-checkbox>
      <p class="mb-0 mt-2">讓該成員能夠使用所有功能</p>
    </v-card-text>

    <v-divider></v-divider>

    <div class="d-flex expansion-panels-button-group mt-4 mb-4">
      <v-btn class="mr-4 white--text" color="#5087e6" @click="all"> 展開 </v-btn>

      <v-btn @click="none"> 全部收縮 </v-btn>
    </div>

    <v-expansion-panels v-model="panel" multiple>
      <v-expansion-panel v-for="(category, category_key) in display_api_category" :key="category_key">
        <v-expansion-panel-header class="category-key">
          {{ category_name_mapper[category_key] }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card-text v-for="(feature, feature_key) in category" :key="feature_key" class="pa-0">
            <v-card-subtitle class="pl-0 pt-0 pb-2 pr-0 text-subtitle-2">
              <v-checkbox
                v-model="feature_name_mapper[feature_key].enable"
                hide-details
                :label="feature_name_mapper[feature_key].name"
                color="info"
                dense
                class="feature-key"
                :disabled="staff_role === 1"
                @change="checkAllSubItem(category_key, feature_key, $event)"
              >
              </v-checkbox>
              <!-- {{ category[feature_key] }} -->
            </v-card-subtitle>

            <v-card-text :key="feature_render_key" class="d-flex pl-0 pr-0 flex-wrap">
              <template v-for="(api, idx) in feature">
                <!-- {{feature}} -->

                <template v-if="api_category_mapper[api.url].disabled_methods">
                  <v-checkbox
                    v-if="
                      api_category_mapper[api.url].display &&
                      !api_category_mapper[api.url].disabled_methods.includes(api.method)
                    "
                    :key="idx"
                    v-model="api.enable"
                    hide-details
                    :label="getMethodLabelName(api)"
                    class="mr-2 gogo"
                    color="info"
                    dense
                    :disabled="staff_role === 1"
                    @click="forceUpdateRender"
                    @change="isAutoCheckParent(category_key, feature_key, api, $event)"
                  >
                  </v-checkbox>
                </template>
                <template v-else>
                  <v-checkbox
                    v-if="api_category_mapper[api.url].display"
                    :key="idx"
                    v-model="api.enable"
                    hide-details
                    :label="getMethodLabelName(api)"
                    class="mr-2 gogo"
                    color="info"
                    dense
                    :disabled="staff_role === 1"
                    @click="forceUpdateRender"
                    @change="isAutoCheckParent(category_key, feature_key, api, $event)"
                  >
                  </v-checkbox>
                </template>
              </template>
            </v-card-text>
            <v-divider v-if="feature_key !== Object.keys(category)[Object.keys(category).length - 1]"> </v-divider>
          </v-card-text>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card-text>
</template>

<script>
// 載入Vuex Helper
import { mapGetters } from 'vuex'

export default {
  // 管理後台權限
  name: 'ManageAdministrationPermissions',
  components: {},
  props: {
    auths: Array,
    staff_info: Object,
  },
  data() {
    return {
      staff_role: null,
      is_all_auth: false,
      // 如果在api_category_mapper沒有特別宣告method的別名，
      // 就用這裡的，不然會以api_category_mapper的別名優先
      method_name_mapper: {
        GET: '查閱',
        POST: '新增',
        PUT: '更新',
        PATCH: '更新',
        DELETE: '刪除',
      },
      category_name_mapper: {
        marketing_tool: '站台優化',
        optimize: '頁面優化',
        optimize_checkout: '結帳優化',
        organization: '組織',
        analysis: '數據分析',
      },
      feature_name_mapper: {
        card: {
          name: '行銷圖卡',
          enable: false,
        },
        iframe: {
          name: '倒數計時器',
          enable: false,
        },
        experience: {
          name: '實驗',
          enable: false,
        },
        view: {
          name: '版本',
          enable: false,
        },
        container: {
          name: '容器',
          enable: false,
        },
        notify: {
          name: '通知',
          enable: false,
        },
        analysis: {
          name: '實驗數據',
          enable: false,
        },
        detect_login: {
          name: '登入異常',
          enable: false,
        },
        page_plugin: {
          name: '衝動外掛',
          enable: false,
        },
      },
      // 真正會顯示的api分類
      display_api_category: {},

      // 就取使用者實際會用到的當作要分的類就好惹....
      api_category_mapper: {
        // LIST
        '/card/card/find/by': {
          category: 'marketing_tool',
          feature: 'card',
          name: '行銷圖卡',
          display: true,
          default: true,
          related_apis: {
            GET: [
              {
                method: 'GET',
                url: '/card/card/get/by',
              },
              {
                method: 'GET',
                url: '/card/card',
              },
            ],
          },
        },
        // 新增修改刪除
        '/card/card': {
          category: 'marketing_tool',
          feature: 'card',
          name: '行銷圖卡',
          display: true,
          disabled_methods: ['GET'],
        },
        '/optimize/experience/v2': {
          category: 'optimize',
          feature: 'experience',
          name: '實驗',
          display: true,
        },
        '/optimize/experience': {
          category: 'optimize',
          feature: 'experience',
          name: '實驗',
          display: true,
          disabled_methods: ['GET'],
        },
        '/optimize/experience/release': {
          category: 'optimize',
          feature: 'experience',
          name: '發布實驗',
          PATCH: '發布實驗',
          display: true,
        },
        '/optimize/experience/disable': {
          category: 'optimize',
          feature: 'experience',
          name: '結束實驗',
          PATCH: '結束實驗',
          display: true,
        },
        '/optimize/experience/copy': {
          category: 'optimize',
          feature: 'experience',
          name: '複製',
          display: true,
          POST: '複製實驗',
        },
        // 取單個版本
        '/optimize/view/by/v2': {
          category: 'optimize',
          feature: 'view',
          name: '版本',
          display: true,
          default: true,
        },
        '/optimize/view': {
          category: 'optimize',
          feature: 'view',
          name: '版本',
          display: true,
        },
        '/optimize/view/copy': {
          category: 'optimize',
          feature: 'view',
          name: '複製版本',
          display: true,
          POST: '複製版本',
        },
        '/iframe/timer': {
          category: 'optimize',
          feature: 'iframe',
          name: '倒數計時器',
          display: true,
        },
        '/optimize/container': {
          category: 'organization',
          feature: 'container',
          name: '容器',
          display: true,
        },
        '/notify/container': {
          category: 'organization',
          feature: 'notify',
          name: '通知',
          display: true,
        },
        '/notify/container/read': {
          category: 'organization',
          feature: 'notify',
          name: '處理',
          display: true,
        },
        '/analysis/total': {
          category: 'analysis',
          feature: 'analysis',
          name: '實驗數據報表',
          display: true,
        },
        '/container/detect/login': {
          category: 'optimize_checkout',
          feature: 'detect_login',
          display: true,
          GET: '查閱數據',
        },
        '/container/threshold': {
          category: 'optimize_checkout',
          feature: 'detect_login',
          display: true,
          GET: '查閱規則',
          POST: '新增規則',
          PUT: '更新規則',
          PATCH: '更新規則',
          DELETE: '刪除規則',
        },
        '/urlview': {
          category: 'optimize',
          feature: 'page_plugin',
          display: true,
        },

        // 挑了幾個不會顯示，但預設會打開的API
        // 不然顯示太多太雜也沒用
        // 這裡是不會顯示在頁面上，但只要更新會被一起打過去的
        // 單隻
        '/card/card/get/by': {
          category: 'marketing_tool',
          feature: 'card',
          name: '行銷圖卡',
          display: false,
          default: true,
        },
        '/card/card/activate': {
          category: 'marketing_tool',
          feature: 'card',
          name: '行銷圖卡',
          display: true,
          PATCH: '發布',
          default: true,
        },
        '/card/card/deactivate': {
          category: 'marketing_tool',
          feature: 'card',
          name: '行銷圖卡',
          display: true,
          PATCH: '停止發布',
          default: true,
        },
        '/card/preview': {
          category: 'marketing_tool',
          feature: 'card',
          name: '行銷圖卡',
          display: false,
          default: true,
        },
        '/analysis/summary': {
          category: 'analysis',
          feature: 'analysis',
          name: '實驗數據報表',
          display: false,
          default: true,
        },
        '/card/card/copy': {
          category: 'marketing_tool',
          feature: 'card',
          name: '行銷圖卡',
          display: false,
          default: true,
        },
        // 頁面優化預覽功能
        // "/optimize/view/preview": {
        //     category: "optimize",
        //     feature: "view",
        //     name: "版本",
        //     display: false,
        //     default: true,
        // },
        // 取單隻iframe 倒數計時器設定
        '/iframe/timer/by': {
          category: 'optimize',
          feature: 'iframe',
          name: '倒數計時器',
          display: false,
          default: true,
        },
        // 取單隻實驗
        '/optimize/experience/by': {
          category: 'optimize',
          feature: 'experience',
          name: '實驗',
          display: false,
          default: true,
        },
        // 設定版本權重
        '/optimize/view/priority': {
          category: 'optimize',
          feature: 'view',
          name: '允許設定權重',
          display: false,
          default: true,
        },
        '/optimize/view/v3': {
          category: 'optimize',
          feature: 'view',
          name: '查閱版本',
          display: false,
          default: true,
        },
        '/optimize/view/copy/by': {
          category: 'optimize',
          feature: 'view',
          name: '取得複製版本',
          display: false,
          default: true,
        },
        '/optimize/container/id': {
          category: 'optimize',
          feature: 'view',
          name: '取得容器資料',
          display: false,
          default: true,
        },
        '/optimize/experience/rule': {
          category: 'optimize',
          feature: 'experience',
          name: '允許新增規則',
          display: false,
          default: true,
          GET: '查閱規則',
          POST: '新增規則',
          PUT: '更新規則',
          DELETE: '刪除規則',
        },
        '/optimize/experience/rule/check': {
          category: 'optimize',
          feature: 'experience',
          name: '允許檢查規則',
          display: false,
          default: true,
        },
        // 允許預覽
        '/optimize/preview/token': {
          category: 'optimize',
          feature: 'view',
          name: '允許預覽',
          display: false,
          default: true,
        },
        '/optimize/container/installed': {
          category: 'organization',
          feature: 'container',
          name: '允許更新容器安裝狀態',
          display: false,
          default: true,
        },
        '/urlview/by': {
          category: 'optimize',
          feature: 'page_plugin',
          name: '取單隻urlview',
          display: false,
          default: true,
        },
        '/urlview/watermarking': {
          category: 'optimize',
          feature: 'page_plugin',
          name: '浮水印',
          display: false,
          default: true,
        },
        '/urlview/counter': {
          category: 'optimize',
          feature: 'page_plugin',
          name: '銷售計數器',
          display: false,
          default: true,
        },
        '/urlview/invoice': {
          category: 'optimize',
          feature: 'page_plugin',
          name: '發票搜集器',
          display: false,
          default: true,
        },
        '/urlview/onlineuser': {
          category: 'optimize',
          feature: 'page_plugin',
          name: '隨機在線人數',
          display: false,
          default: true,
        },
        '/urlview/overlap': {
          category: 'optimize',
          feature: 'page_plugin',
          name: '檢查urlview是否重疊',
          display: false,
          default: true,
        },
        '/urlview/preview': {
          category: 'optimize',
          feature: 'page_plugin',
          name: 'urlview預覽功能',
          display: false,
          default: true,
        },
        '/urlview/activate': {
          category: 'optimize',
          feature: 'page_plugin',
          name: 'urlview發布',
          display: true,
          default: true,
          PATCH: '發布',
        },
        '/urlview/deactivate': {
          category: 'optimize',
          feature: 'page_plugin',
          name: 'urlview取消發布',
          display: true,
          default: true,
          PATCH: '停止發布',
        },
      },
      other_auths: [],
      panel: [],
      feature_render_key: 0,
    }
  },
  watch: {},
  created: async function () {
    let that = this
    console.log('開啟權限列表')
    console.log(this.auths)
    console.log(this.staff_info)

    // 取該成員的身份
    // 1 是管理員 (開放所有權限，所以表示要全選權限並且不能再選取，因為選了也沒意義)
    // 2 是一般身份
    this.staff_role = this.staff_info['role']

    // 把各個API依照路徑來把GET POST PATCH PUT DELETE 來集中在一起
    this.auths.forEach(function (auth) {
      if (that.api_category_mapper[auth.url]) {
        if (!that.api_category_mapper[auth.url]['apis']) {
          that.api_category_mapper[auth.url]['apis'] = []
        }
        // 不顯示出來的api的enable拿預設的值
        if (that.api_category_mapper[auth.url].display === false) {
          auth.enable = that.api_category_mapper[auth.url].default
        }
        that.api_category_mapper[auth.url]['apis'].push(auth)
      } else {
        that.other_auths.push(auth)
      }
    })

    console.log('that.api_category_mapper', that.api_category_mapper)
    console.log('that.other_auths', that.other_auths)

    let api_paths = Object.keys(that.api_category_mapper)

    // 依照 GET POST PATCH DELETE的順序排列
    api_paths.forEach(function (api_path) {
      that.api_category_mapper[api_path].apis.sort(that.sortAPI)
    })

    // 把所有API依照用category和feature進行再次分組
    // category代表大功能 e.g. 行銷小工具
    // feature代表小功能 e.g. 行銷圖卡
    api_paths.forEach(function (api_path) {
      let api = that.api_category_mapper[api_path]
      if (!that.display_api_category[api.category]) {
        that.display_api_category[api.category] = {}
      }
      if (!that.display_api_category[api.category][api.feature]) {
        that.display_api_category[api.category][api.feature] = []
      }
      that.display_api_category[api.category][api.feature] = that.display_api_category[api.category][
        api.feature
      ].concat(api.apis)
    })

    if (this.staff_role === 1) {
      this.selectAllAuth(true)
      return
    }

    // 如果feature的display api全勾的話，也要把全選feature的checkbox勾起來
    Object.keys(this.display_api_category).forEach(function (category_key) {
      Object.keys(that.display_api_category[category_key]).forEach(function (feature_key) {
        let is_check_feature = true
        for (let idx = 0; idx < that.display_api_category[category_key][feature_key].length; idx++) {
          let api = that.display_api_category[category_key][feature_key][idx]
          if (that.api_category_mapper[api.url].display) {
            console.log(api.enable)
            if (api.enable === false) {
              is_check_feature = false
              break
            }
          }
        }
        that.feature_name_mapper[feature_key].enable = is_check_feature
      })
    })

    let is_all_auth = true
    let feature_keys = Object.keys(this.feature_name_mapper)
    console.log('this.feature_name_mapper', this.feature_name_mapper)
    for (let idx = 0; idx < feature_keys.length; idx++) {
      console.log(this.feature_name_mapper[feature_keys[idx]])
      if (this.feature_name_mapper[feature_keys[idx]].enable === false) {
        is_all_auth = false
        break
      }
    }
    this.is_all_auth = is_all_auth
    console.log('that.display_api_category', that.display_api_category)
    console.log('開啟權限列表結束')
  },
  mounted: function () {},
  methods: {
    getMethodLabelName: function (item) {
      let name = this.method_name_mapper[item.method]
      if (this.api_category_mapper[item.url][item.method]) {
        name = this.api_category_mapper[item.url][item.method]
      }
      return name
    },
    sortAPI: function (a, b) {
      return (
        Object.keys(this.method_name_mapper).indexOf(a.method) - Object.keys(this.method_name_mapper).indexOf(b.method)
      )
    },
    // 選取/或取消選取 功能底下的子method，不包含沒顯示的
    checkAllSubItem(category, feature, is_check) {
      // let that = this
      console.log('category', category)
      console.log('feature', feature)
      console.log('e', is_check)
      console.log('this.display_api_category[category][feature]', this.display_api_category[category][feature])

      this.display_api_category[category][feature].forEach(function (api) {
        api.enable = is_check
      })
      let feature_keys = Object.keys(this.feature_name_mapper)
      let is_selected_all_auth = true
      for (let idx = 0; idx < feature_keys.length; idx++) {
        if (this.feature_name_mapper[feature_keys[idx]].enable === false) {
          is_selected_all_auth = false
          break
        }
      }
      this.is_all_auth = is_selected_all_auth
    },
    // 當所有功能底下的子method，全部選取時自動選取 feature的全選checkbox
    // 反之只要有一個沒有選就不勾
    isAutoCheckParent: function (category_key, feature_key, change_api, is_activate) {
      console.log('變', change_api)
      console.log('is_activate', is_activate)
      let that = this
      let related_apis = this.api_category_mapper[change_api.url]['related_apis']
      let method_related_apis = []
      if (related_apis) {
        method_related_apis = related_apis[change_api.method]
        console.log('method_related_api', method_related_apis)
      }

      let is_check = true
      let apis = this.display_api_category[category_key][feature_key]
      console.log('feature_api', apis.length)
      if (method_related_apis.length > 0) {
        method_related_apis.forEach(function (method_related_api) {
          let related_idx = apis.findIndex(function (api) {
            return api.url === method_related_api.url && api.method === method_related_api.method
          })
          console.log('related_idx', related_idx)

          if (related_idx !== -1) {
            if (is_activate) {
              that.display_api_category[category_key][feature_key][related_idx].enable = true
            } else {
              that.display_api_category[category_key][feature_key][related_idx].enable = false
            }
          }
        })
      }

      for (let idx = 0; idx < apis.length; idx++) {
        let api = apis[idx]
        if (this.api_category_mapper[api.url].display === true && api.enable === false) {
          is_check = false
          break
        }
      }
      if (is_check) {
        this.feature_name_mapper[feature_key].enable = true
        let feature_keys = Object.keys(this.feature_name_mapper)
        let is_selected_all_auth = true
        for (let idx = 0; idx < feature_keys.length; idx++) {
          if (this.feature_name_mapper[feature_keys[idx]].enable === false) {
            is_selected_all_auth = false
            break
          }
        }
        this.is_all_auth = is_selected_all_auth
      } else {
        this.feature_name_mapper[feature_key].enable = false
        this.is_all_auth = false
      }
    },
    // 勾選/取消勾選所有權限
    selectAllAuth: function (is_all_auth) {
      let that = this
      console.log('is_all_auth', is_all_auth)

      let category_keys = Object.keys(this.display_api_category)
      category_keys.forEach(function (category_key) {
        let feature_keys = Object.keys(that.display_api_category[category_key])
        feature_keys.forEach(function (feature_key) {
          that.display_api_category[category_key][feature_key].forEach(function (api) {
            if (that.api_category_mapper[api.url].display) {
              api.enable = is_all_auth
            }
          })

          that.feature_name_mapper[feature_key].enable = is_all_auth
        })
      })
      this.is_all_auth = is_all_auth
      this.all()
    },
    all() {
      let categories = Object.keys(this.display_api_category)
      this.panel = categories.map(function (c, idx) {
        return idx
      })
    },
    none() {
      this.panel = []
    },
    forceUpdateRender() {
      this.feature_render_key += 1
    },
    changeRoleCallBack: function (role) {
      this.staff_role = role
      if (this.staff_role === 1) {
        this.selectAllAuth(true)
      }
    },
  },
  computed: {
    ...mapGetters(['selectedAdmin', 'selectedOrg']),
  },
}
</script>

<style scoped>
.btn-danger {
  background: #e3262e;
  background-image: linear-gradient(180deg, #e3262e, #ab171e);
  border-radius: 2px;
  color: #fff;
  border: 1px solid #ab171e;
  text-decoration: none;
  min-width: 40px;
  margin-bottom: 5px;
  box-shadow: inset 0 1px 1px #ff7b81, 0 2px 2px -1px rgba(0, 0, 0, 0.2);
}

.btn-primary {
  background: #20a6f2;
  background-image: linear-gradient(180deg, #20a6f2, #1092d3);
  border-radius: 2px;
  color: #fff;
  border: 1px solid #0f88c5;
  text-decoration: none;
  min-width: 32px;
  margin-bottom: 5px;
  box-shadow: inset 0 1px 1px #77bdf4, 0 2px 2px -1px rgba(0, 0, 0, 0.2);
}
::v-deep .category-key {
  font-size: 18px !important;
  font-weight: 500;
}
::v-deep .feature-key .v-label {
  font-size: 16px !important;
  color: #393e48 !important;
}
::v-deep .gogo .v-label {
  font-size: 14px !important;
}
</style>
